export default __webpack_public_path__ + "static/media/aeroview.89575225.png";